// eslint-disable-next-line import/no-unresolved
class SlideIn extends HTMLElement {
  constructor () {
    super()
    this.isTicking = false
    // eslint-disable-next-line
    this.lastKnownY = window.scrollY

    this.itemEls = document.querySelectorAll('[data-el="slide-in.item"]')

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()

    this.setupListeners()
  }

  setupListeners () {
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    // eslint-disable-next-line
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.animateOnScroll()
  }

  animateOnScroll () {
    this.itemEls.forEach(item => {
      const itemTriggerPoint =
        this.getOffsetTop(item) - window.innerHeight + 100

      if (
        this.lastKnownY > itemTriggerPoint
      ) {
        this.classList.add(`${this.classList[0]}-animate`)

        return
      }
    })
  }

  getOffsetTop (el, parent = document.body, offsetTop = 0) {
    if (!el.offsetParent) {
      return el.offsetTop
    }
    if (!isNaN(el.offsetTop)) {
      offsetTop += el.offsetTop
    }

    return el.offsetParent === parent
      ? offsetTop
      : this.getOffsetTop(el.offsetParent, parent, offsetTop)
  }
}

customElements.define('slide-in', SlideIn)
